// source: wo_install_date_service.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js');
goog.object.extend(proto, google_protobuf_empty_pb);
var wo_install_date_message_pb = require('./wo_install_date_message_pb.js');
goog.object.extend(proto, wo_install_date_message_pb);
var wo_common_message_pb = require('./wo_common_message_pb.js');
goog.object.extend(proto, wo_common_message_pb);
goog.exportSymbol('proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDateRequest', null, global);
goog.exportSymbol('proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDateResultResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDateRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDateRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDateRequest.displayName = 'proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDateRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDateResultResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDateResultResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDateResultResponse.displayName = 'proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDateResultResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDateRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDateRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDateRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDateRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
request: (f = msg.getRequest()) && wo_install_date_message_pb.InstallDate.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDateRequest}
 */
proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDateRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDateRequest;
  return proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDateRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDateRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDateRequest}
 */
proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDateRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new wo_install_date_message_pb.InstallDate;
      reader.readMessage(value,wo_install_date_message_pb.InstallDate.deserializeBinaryFromReader);
      msg.setRequest(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDateRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDateRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDateRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDateRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRequest();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      wo_install_date_message_pb.InstallDate.serializeBinaryToWriter
    );
  }
};


/**
 * optional InstallDate request = 1;
 * @return {?proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDate}
 */
proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDateRequest.prototype.getRequest = function() {
  return /** @type{?proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDate} */ (
    jspb.Message.getWrapperField(this, wo_install_date_message_pb.InstallDate, 1));
};


/**
 * @param {?proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDate|undefined} value
 * @return {!proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDateRequest} returns this
*/
proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDateRequest.prototype.setRequest = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDateRequest} returns this
 */
proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDateRequest.prototype.clearRequest = function() {
  return this.setRequest(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDateRequest.prototype.hasRequest = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDateResultResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDateResultResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDateResultResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDateResultResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
result: (f = msg.getResult()) && wo_install_date_message_pb.InstallDateResult.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDateResultResponse}
 */
proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDateResultResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDateResultResponse;
  return proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDateResultResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDateResultResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDateResultResponse}
 */
proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDateResultResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new wo_install_date_message_pb.InstallDateResult;
      reader.readMessage(value,wo_install_date_message_pb.InstallDateResult.deserializeBinaryFromReader);
      msg.setResult(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDateResultResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDateResultResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDateResultResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDateResultResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getResult();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      wo_install_date_message_pb.InstallDateResult.serializeBinaryToWriter
    );
  }
};


/**
 * optional InstallDateResult result = 1;
 * @return {?proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDateResult}
 */
proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDateResultResponse.prototype.getResult = function() {
  return /** @type{?proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDateResult} */ (
    jspb.Message.getWrapperField(this, wo_install_date_message_pb.InstallDateResult, 1));
};


/**
 * @param {?proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDateResult|undefined} value
 * @return {!proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDateResultResponse} returns this
*/
proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDateResultResponse.prototype.setResult = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDateResultResponse} returns this
 */
proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDateResultResponse.prototype.clearResult = function() {
  return this.setResult(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1.InstallDateResultResponse.prototype.hasResult = function() {
  return jspb.Message.getField(this, 1) != null;
};


goog.object.extend(exports, proto.Olameter.WFMS.WorkOrderExecution.InstallDate.v1);
